import { useEffect, useRef } from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';

import { required } from '@front/common/src/forms/validations';
import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import { CONTENT_PADDING as ACCORDION_CONTENT_PADDING } from '@front/web-ui/src/components/accordion/accordion';
import Button from '@front/web-ui/src/components/button/button';
import { InputAdapter } from '@front/web-ui/src/forms/adapters';
import { DesktopAndTablet } from '@front/web-ui/src/styles/media-queries';
import { minWidth } from '@front/web-ui/src/styles/mixins';

const t = translate('components.promo_code');

const StyledForm = styled.form`
  width: 100%;
`;

const FormContent = styled.div`
  display: flex;
  justify-content: center;
  margin: ${toRem(5)} ${toRem(40)};

  ${minWidth.md`
    margin: ${toRem(10)} 0 0 ${toRem(ACCORDION_CONTENT_PADDING)};
  `}
`;

const StyledButton = styled(Button)`
  margin-left: ${toRem(10)};
`;

type PromoCodeInputProps = {
  handleSubmit: () => void;
  invalid?: boolean;
  isLoading?: boolean;
};

const PromoCodeInput = ({ handleSubmit, invalid = false, isLoading = false }: PromoCodeInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef?.current) inputRef.current.focus();
  }, []);

  return (
    <StyledForm onSubmit={handleSubmit} id='promo_input_form'>
      <FormContent>
        <Field
          component={InputAdapter}
          name='promoCode'
          type='text'
          label={t('inputs.promo_code.placeholder')}
          id='promo-code'
          validate={required('promo_code')}
          ref={inputRef}
        />
        <DesktopAndTablet>
          <StyledButton type='submit' isDisabled={invalid} isLoading={isLoading} size='lg'>
            {t('base.add')}
          </StyledButton>
        </DesktopAndTablet>
      </FormContent>
    </StyledForm>
  );
};

export default PromoCodeInput;
